import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';

import { I18nService } from '@core/i18n-legacy';
import type { DataSourceService } from '@core/views-types';
import { AskTemplatesService } from '@tellent-ask-hr/templates-logic';

@Injectable()
export class UserTemplatesDataSourceService implements DataSourceService {
  private readonly i18n = inject(I18nService);
  private readonly askTemplatesService = inject(AskTemplatesService);

  public hasMoreSettings$ = of(true);
  public hasSampleData$ = of(false);
  public isSampleDataInProgress$ = of(false);
  public viewPageHeaderComponent$ = of(null);
  public pageCtaVisible$ = of(false);

  public refreshData$ = this.askTemplatesService.getViewRefreshEvents$();
  public translations = {
    dataSourceName: 'app.views_candidates.name',
    pageCta: 'app.views_candidates.view_add_candidate',
  };

  public defaultEmptyState$ = of({
    header: this.i18n.translate('tlc.ask_hr.user_forms.empty_state.heading'),
    description: '',
    icon: <const>'local-activity',
  });

  public filteredEmptyState$ = of({
    header: this.i18n.translate('tlc.ask_hr.user_forms.empty_state.heading'),
    description: '',
    icon: <const>'local-activity',
  });

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRemoveSampleData = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onPageCtaClick = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRecordClick = (template: { id: number }) => {};

  public openNewTicket(templateId: number): void {
    this.askTemplatesService.navigateToCreateTicket(templateId);
  }
}
